import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0090d1f1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090d1f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0090d1f1')) {
      api.createRecord('0090d1f1', component.options)
    } else {
      api.reload('0090d1f1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0090d1f1&scoped=true", function () {
      api.rerender('0090d1f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/broadcast/index.vue"
export default component.exports